import { BaseThunkType, InferActionsTypes } from "./store";
import {
  IAccommodations,
  ICars,
  IExcursions,
  ILanguages,
} from "../types/services";

import { servicesAPI } from "../api/services-api";

const initialState = {
  accommodations: null as IAccommodations | null,
  cars: null as ICars | null,
  excursions: null as IExcursions | null,
  languages: null as ILanguages | null,
  cart: [] as any,

  total: 0,
};

type InitialState = typeof initialState;
type Actions = InferActionsTypes<typeof actions>;
type ThunkType = BaseThunkType<Actions>;

const servicesReducer = (
  state = initialState,
  action: Actions
): InitialState => {
  switch (action.type) {
    case "ADD_TO_CART": {
      let issetInState = false;

      console.log(action.newItem);
      let newItems = state.cart.map((item: any) => {
        if (
          item.room === action.newItem.room &&
          item.date.start === action.newItem.date.start &&
          item.date.end === action.newItem.date.end &&
          item.type !== "transportation" &&
          item.type !== "excursion"
        ) {
          issetInState = true;
          item.qty += action.newItem.qty;
        } else if (
          item.type === "transportation" &&
          item.rideType === action.newItem.rideType &&
          item.carId === action.newItem.carId &&
          item.date === action.newItem.date
        ) {
          issetInState = true;
          item.qty += action.newItem.qty;
        } else if (
          item.type === "excursion" &&
          item.tourType === action.newItem.tourType &&
          item.excursionId === action.newItem.excursionId
        ) {
          issetInState = true;
          item.qty += action.newItem.qty;
        }
        return item;
      });
      if (!issetInState) {
        newItems.push(action.newItem);
      }

      return {
        ...state,
        cart: [...newItems],
        total: issetInState
          ? state.total
          : state.total +
            action.newItem.price *
              action.newItem.qty *
              (action.newItem.daysAmount ? action.newItem.daysAmount : 1),
      };
    }

    case "REMOVE_FROM_CART": {
      const removedElement = state.cart.find(
        (item: any) => item.id === action.removeItem
      );

      return !removedElement.id
        ? state
        : {
            ...state,
            cart: [
              ...state.cart.filter(
                (item: any) => item.id !== action.removeItem
              ),
            ],
            total:
              state.total -
              removedElement.price *
                +removedElement.qty *
                (removedElement.daysAmount ? removedElement.daysAmount : 1) *
                (removedElement.return ? 2 : 1),
          };
    }
    case "RESET_CART": {
      return { ...state, cart: [...initialState.cart], total: 0 };
    }
    case "SETTING_ACCOMMODATION_DATA": {
      return {
        ...state,
        accommodations: {
          ...action.payload,
        },
      };
    }
    case "SETTING_CAR_DATA": {
      return {
        ...state,
        cars: {
          ...action.payload,
        },
      };
    }
    case "SETTING_EXCURSIONS_DATA": {
      return {
        ...state,
        excursions: {
          ...action.payload,
        },
      };
    }
    case "SETTING_EXCURSION_LANGUAGES_DATA": {
      return {
        ...state,
        languages: {
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
};

export const getAccommodations = (): ThunkType => async (dispatch) => {
  try {
    const accommodations = (await servicesAPI.getHotels()) as IAccommodations;
    dispatch(actions.setAccommodations(accommodations));
  } catch (e) {}
};

export const getCars = (): ThunkType => async (dispatch) => {
  try {
    const cars = (await servicesAPI.getCars()) as ICars;
    dispatch(actions.setCars(cars));
  } catch (e) {}
};

export const getExcursions = (): ThunkType => async (dispatch) => {
  try {
    const cars = (await servicesAPI.getExcursions()) as IExcursions;
    dispatch(actions.setExcursions(cars));
  } catch (e) {}
};

export const getExcursionsLanguages = (): ThunkType => async (dispatch) => {
  try {
    const languages =
      (await servicesAPI.getExcursionsLanguages()) as ILanguages;
    dispatch(actions.setExcursionsLanguages(languages));
  } catch (e) {}
};

export const actions = {
  addToCartAC: (item: any) => ({ type: "ADD_TO_CART", newItem: item } as const),
  removeFromCartAC: (item: any) =>
    ({
      type: "REMOVE_FROM_CART",
      removeItem: item,
    } as const),
  setAccommodations: (user: IAccommodations) =>
    ({ type: "SETTING_ACCOMMODATION_DATA", payload: user } as const),
  setCars: (user: ICars) =>
    ({ type: "SETTING_CAR_DATA", payload: user } as const),
  setExcursions: (user: IExcursions) =>
    ({ type: "SETTING_EXCURSIONS_DATA", payload: user } as const),
  setExcursionsLanguages: (user: ILanguages) =>
    ({ type: "SETTING_EXCURSION_LANGUAGES_DATA", payload: user } as const),
  resetCart: () => ({ type: "RESET_CART" } as const),
};

export default servicesReducer;
